// Frequency unit helpers used across the frontend

// Convert MHz to Hz. Rounds to nearest integer Hz.
export function mhzToHz(mhz: number): number {
  const v = Number(mhz) || 0;
  return Math.round(v * 1_000_000);
}

// Convert Hz to MHz for UI. If value is already small (looks like MHz),
// return it unchanged to avoid double conversion when importing legacy data.
export function hzToMhz(hz: number): number {
  const v = Number(hz) || 0;
  return v / 1_000_000;
}
